export default "__VITE_ASSET__BXjoQSl1__"